import { defaultsDeep } from 'lodash-es'
import type { RecursiveRequired, Settings } from '#/global'
import settingsDefault from '@/settings.default'

const globalSettings: Settings.all = {
  "app": {
    "enablePermission": true,
    "enableDynamicTitle": true
  },
  "menu": {
    "mode": "head",
    "subMenuUniqueOpened": false,
    "enableSubMenuCollapseButton": true
  },
  "topbar": {
    "mode": "sticky"
  },
  "toolbar": {
    "breadcrumb": true,
    "navSearch": false,
    "fullscreen": true,
    "colorScheme": true,
    "pageReload": true
  },
  "copyright": {
    "enable": false,
    "company": "蒲公英（广州）数字营销有限公司",
    "website": "https://beian.miit.gov.cn",
    "beian": "粤ICP备2023016758号"
  }
}

export default defaultsDeep(globalSettings, settingsDefault) as RecursiveRequired<Settings.all>